import { slugifyTopic, unslugify } from "@/utils/slugify";

export const GUEST_INTEREST_COOKIE = "mp_guest_interest";
export const GUEST_INTEREST_MAX_AGE = 60 * 60 * 24 * 400;

export const POLITICAL_STANCE_CATEGORIES = [
  "All",
  "Economy and Jobs",
  "Healthcare",
  "Education",
  "Environment and Climate Change",
  "Immigration",
  "Foreign Policy",
  "Taxation",
  "Social Security and Welfare",
  "Criminal Justice and Law Enforcement",
  "Gun Control",
  "Abortion and Reproductive Rights",
  "Civil Rights and Liberties",
  "LGBTQ+ Rights",
  "Religious Freedom",
  "Drug Policy",
  "Technology and Privacy",
  "Infrastructure and Transportation",
  "Trade and Commerce",
  "Housing and Urban Development",
  "Agriculture and Rural Issues",
  "Energy Policy",
  "Veterans Affairs",
  "Campaign Finance and Electoral Reform",
  "Animal Rights",
  "National Security and Counterterrorism",
  "Science and Research Policy",
  "Public Safety and Emergency Services",
  "Cultural Policies (Arts, Media, etc.)",
  "Congressional Nomination",
  "Congressional Procedure",
  "Other",
] as const;

export const GUEST_ISSUE_OPTIONS = POLITICAL_STANCE_CATEGORIES.filter(
  (category) => category !== "All"
);

const ISSUE_CATEGORY_BY_SLUG = new Map(
  GUEST_ISSUE_OPTIONS.map((category) => [slugifyTopic(category), category])
);

export function parseLegislationInterests(
  value: string | readonly string[] | null | undefined
): string[] {
  const rawValue = typeof value === "string" ? value : value?.join(",") ?? "";
  const fragments = rawValue
    .split(",")
    .map((fragment) => fragment.trim())
    .filter(Boolean);
  const interests: string[] = [];

  for (let start = 0; start < fragments.length;) {
    let matchedCategory: string | undefined;
    let nextStart = start + 1;

    for (let end = fragments.length; end > start; end--) {
      const candidate = fragments.slice(start, end).join(", ");
      const category = ISSUE_CATEGORY_BY_SLUG.get(slugifyTopic(candidate));

      if (category) {
        matchedCategory = category;
        nextStart = end;
        break;
      }
    }

    interests.push(matchedCategory ?? fragments[start]);
    start = nextStart;
  }

  return interests;
}

export function resolveIssueCategory(value: unknown): string {
  const issueSlug = slugifyTopic((value ?? "").toString());

  return (
    GUEST_ISSUE_OPTIONS.find((category) => slugifyTopic(category) === issueSlug) ??
    unslugify(value)
  );
}

export function parseGuestInterest(value: string | null | undefined): string | null {
  if (!value) return null;

  let decodedValue: string;
  try {
    decodedValue = decodeURIComponent(value);
  } catch {
    return null;
  }

  return GUEST_ISSUE_OPTIONS.some((category) => category === decodedValue)
    ? decodedValue
    : null;
}